export const formatHierarchy: (
  projectHierarchy: undefined | string[],
  pageHierarchy: string[]
) => string[] = (projectHierarchy, pageHierarchy) => {
  const heirachy = [...(pageHierarchy ?? [])];

  if (Array.isArray(projectHierarchy)) {
    heirachy.splice(0, 0, ...projectHierarchy);
  }

  // we always want 3 nodes - if we don't have 3, add the last node over and over until we get 3
  while (heirachy.length < 3) {
    // we want to append '-home' to any auto-added item.
    // we are first replacing '-home' with '' to make sure it doesn't get a format like 'team-home-home' we we add it
    heirachy.push(
      heirachy[heirachy.length - 1].replace('-home', '').concat('-home')
    );
  }

  return heirachy;
};

export const formatPageType: (hierarchy: string[]) => string = hierarchy => {
  if (hierarchy.length === 1) {
    return hierarchy[0].toLowerCase();
  }
  // this rule to to convert stuff like ['team', 'team-home'] to 'team_home'
  if (hierarchy[1].indexOf(hierarchy[0]) === 0) {
    return hierarchy[1].replace('-', '_').toLowerCase();
  }

  // this will convert stuff like ['team', 'roster', 'parent-manage'] to 'team_roster'
  return `${hierarchy[0]}_${hierarchy[1]}`.toLowerCase();
};

export const sanitizeTrackingTerm = (text: string) =>
  text.toLowerCase().replaceAll(' ', '-');
